module.exports.HOURS = new Array(24 + 1).join('0').split('')
module.exports.TWELVE_HOURS = [
    12,1,2,3,4,5,6,7,8,9,10,11
]
module.exports.MINUTES = new Array(60 + 1).join('0').split('')
